enum MessengerPostType {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
  BILLED = "BILLED",
  UPDATED = "UPDATED",
  USER_ENTRY = "USER_ENTRY",
}

export default MessengerPostType;
